import { useEffect, useCallback } from "react";
import { getObligationRecurrenceDetails } from "api/services/obligationsServices";
import useObligationDetailsStore from "../stores/useObligationDetailsStore";

// Pure caller - Stores results in the module's store
export function useRecurrenceData(externalRecurrenceId) {
  const setSelectedRecurrence = useObligationDetailsStore((s) => s.setSelectedRecurrence);
  const setLoadingRecurrence = useObligationDetailsStore((s) => s.setLoadingRecurrence);

  const fetchRecurrenceData = useCallback(async (recurrenceId) => {
    setLoadingRecurrence(true);
    try {
      const response = await getObligationRecurrenceDetails(recurrenceId);
      setSelectedRecurrence(response);
      return response;
    } catch (error) {
      setSelectedRecurrence(null);
      return null;
    } finally {
      setLoadingRecurrence(false);
    }
  }, [setSelectedRecurrence, setLoadingRecurrence]);

  // Auto-fetch recurrence details if an id is provided any time it changes
  useEffect(() => {
    if (!externalRecurrenceId) return;
    fetchRecurrenceData(externalRecurrenceId);
  }, [externalRecurrenceId, fetchRecurrenceData]);

  return {
    fetchRecurrenceData,
  };
};